import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import PropTypes from 'prop-types';
import { Radio, FormControlLabel } from '@material-ui/core';

const RenderRadioGroup = props => {
    const { label, setVal, data, values, valor, ...group } = props
    // const [val, setVal] = React.useState(props.value)
    // console.log('props radio', props)
    const handleChange = event => {
        event.persist()
        setVal(event.target.value);
    };
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{label}</FormLabel>
            <RadioGroup
                defaultValue={values}
                {...group}
                onChange={handleChange}
                value={valor}
            >
                {
                    data.map(rad => {
                        return <FormControlLabel key={rad.value} value={rad.value} control={<Radio />} label={rad.label} />
                    })
                }
            </RadioGroup>
        </FormControl>
    );
};

RenderRadioGroup.propTypes = {
    //values: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    setVal: PropTypes.func.isRequired,
    // defaultValue: PropTypes.string.isRequired,
};

export default RenderRadioGroup;